import script from "./CaratMark.vue?vue&type=script&setup=true&lang=js"
export * from "./CaratMark.vue?vue&type=script&setup=true&lang=js"

import "./CaratMark.vue?vue&type=style&index=0&id=97353ea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97353ea8"]])

export default __exports__